import { render } from "./BoutonBleu.vue?vue&type=template&id=923ba8d6&scoped=true"
import script from "./BoutonBleu.vue?vue&type=script&lang=js"
export * from "./BoutonBleu.vue?vue&type=script&lang=js"

import "./BoutonBleu.vue?vue&type=style&index=0&id=923ba8d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923ba8d6"]])

export default __exports__